import { useAuthStore } from '@/stores/authStore'

export function useAuth() {
  const user = useAuthStore((s) => s.user)
  const isLoading = useAuthStore((s) => s.isLoading)
  const accessToken = useAuthStore((s) => s.accessToken)

  const isAuthenticated = !!accessToken && !!user

  const displayName =
    user
      ? [user.first_name, user.last_name].filter(Boolean).join(' ') || user.email
      : ''

  const initials =
    user
      ? (user.first_name?.[0] ?? '') + (user.last_name?.[0] ?? user.email[0])
      : ''

  const isAdmin = user?.role === 'admin'
  const isPlatformAdmin = !!user?.is_platform_admin

  return { user, isAuthenticated, isLoading, displayName, initials: initials.toUpperCase(), isAdmin, isPlatformAdmin }
}
